<template>
  <div>
    <ul :style="{height:`${height}`}" ref="lineWidth" v-show="dsfBlockId || realContent.filter(tag => tag.flowType == 'flow').length || swindow">
      <li v-for="(ite,ind) in realContent" :key="ind" v-show="dsfBlockId || (NotMedia ? ite.flowType != 'block' : true) || swindow">
        <div class="search-block" ref="cont">
          <a href="javascript:;" :class="['hover-systemBlue',{'curr':ite.num >= 1 ? ite.show : ind == chooseInd},{Icon:ite.flower}]" @click="chooseConditions(ind,ite)">{{ite.name}}</a>
        </div>
      </li>
      <div class="label-more" :style="{display:tabCalc>scrollWidth?'block':'none'}">
        <a href="javascript:;" class="hover-systemBlue" @click="showMore()">{{text}}</a>
      </div>
    </ul>
    
    <Conditions :cont="contents" v-if="contents.length"  ref="conditions"/>
  </div>
</template>
<script>
export default {
  name:'Conditions',
  props:{
    cont:Array,
    choose:Number,
    swindow:Boolean
  },
  data(){
    return{
      NotMedia:this.getQuery('flowEnName') != 'media-scene',
      dsfBlockId : this.getQuery('zxBlockId'),
      realContent:[],
      chooseInd:-1,
      chooseInds:-1,
      chooseIndex:-1,
      show:-1,
      height:'',
      text:'更多 ∨',
      contTop:0,
      contents:[],
      tabCalc:0,
      scrollWidth:0,
      contentsO:[{name:'传媒',show:false,num:1,choose:0,flowType:'flow'},{name:'产品',show:false,num:1,choose:1},{name:'直播',show:false,num:1,choose:-1}],
      contentsT:[{name:'视频',show:false,num:2,choose:1,flowType:'flow'},{name:'音频',show:false,num:2,choose:3},{name:'图片',show:false,num:2,choose:4},{name:'文档',show:false,num:2,choose:8}]
    }
  },
  mounted(){
    this.scrollWidth = this.$refs.lineWidth.clientWidth - 200;
    this.realContent = this.cont;
    this.getWidth(this.cont);
  },
  //跨级触发方法
  inject: ["fatherMethod","emitChoose"],
  methods:{
    getWidth(val){
      var twid = 0;
      val.filter((ite) => ite.name).forEach(element => {
      if (element.name) {
          twid += ((element.name.length * 14) + 10)
      }
      });
      this.tabCalc = twid;
    },
    getTop(ind){
      var top =  this.$refs['cont'][ind].offsetTop;
      this.contTop = top+31;
    },
    //选择框点击
    chooseConditions(ind,item){
      if(item.neo == 1){
        this.contents=this.contentsO;
      }
      if(item.neo == 2){
        this.contents=this.contentsT;
      }
      if(item.num >= 1){
        var index = this.realContent.findIndex(tag => tag.show);
        if(index> -1 && index == ind){
          this.realContent[index].show = false;
          this.emitChoose(item);
          return;
        }else{
          this.realContent.filter(tag => tag.show = false);
          this.realContent[ind].show = true;
        }
      }
      // if(item.num == 2){
        
      //   var arr = this.realContent.filter(tag => tag.show);
      //   if(arr.length && arr.findIndex(ite => ite.name == item.name) > -1){
      //     this.realContent[ind].show = false;
      //     this.emitChoose(item);
      //     return;
      //   }else{
      //     this.realContent.filter(tag=>tag.choose == item.choose)[0].show = true;
      //   }
      // }
      if(ind != this.chooseInd){
        this.chooseInd = ind;
        if(this.$refs.conditions){
            this.$refs.conditions.del();
          }
      }
      this.fatherMethod({name:item.name,num:item.num,ite:item,choose:item.choose});
      if(item.flowType == 'block' || item.neo || item.num || this.getQuery('assetId')) return;
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
          appId:this.getQuery('appId'),
          flowId:item.id,
          leftId: (this.getQuery('zxBlockId') || item.flower) ? '' : this.getQuery('zzBlockId'),
          floorEnName:this.getQuery('flowEnName') ? this.getQuery('flowEnName') : ''
      }).then(res => {
        if(res.state == 1 && res.data[0].dataArr.length){
          this.contents = res.data[0].dataArr;
          var dom = document.querySelector('.search-row');
          this.$nextTick(()=>{
            dom.scrollTop = dom.scrollHeight;
          })
        }else{
          if(this.$refs.conditions){
            this.del();
          }
        }
      })
    },
    //悬浮框点击
    chooseCondition(ind,item,index){
      this.chooseInds = ind;
      this.chooseIndex = index;
      this.show = -1;
      this.$emit('emitChoose',{name:item,num:this.index});
    },
    //展示更多
    showMore(){
      if(this.text == '更多 ∨'){
        this.text = '收起 ∧';
        this.height = 'auto';
      }else{
        this.text = '更多 ∨';
        this.height = '';
      }
    },
    del(item){
      if(item && item.num == 1){
        this.contentsO.filter(tag=>tag.show = false);
        return;
      }
      if(item && item.num == 2){
        this.contentsT.filter(tag=>tag.name == item.name)[0].show = false;
        return;
      }
      if(this.$refs.conditions && item){
        this.$refs.conditions.del(item);
      }
      if(!item || !item.num){
        this.contents = [];
        this.chooseInd = -2;
      }
    }
  },
  watch:{
    cont:function(val){
      if(val){
          this.realContent = this.cont;
          this.getWidth(val);
      }
    }
  }
}
</script>
<style scoped>
.search-row ul{
  padding-top: 8px;
  position: relative;
  margin: 1px 0 0 130px;
  padding-right:70px;
  height: 36px;
  overflow: hidden;
  border-bottom: 1px dashed #dddddd;
}
.search-row ul li{
  float: left;
  margin: 0 5px;
  height: 36px;
}
.search-row ul li .search-block{
  position: relative;
  height: 36px;
}
.search-row ul li .hover-systemBlue{
  display: block;
  line-height: 26px;
  padding: 0 5px;
  font-size: 14px;
  border-radius: 3px;
  color: #666;
}
.search-row ul li .hover-systemBlue.Icon{
  padding-left: 20px;
  background: url('../assets/image/images/icons/sub_icon_menu_black.png') no-repeat 3px center / 13px;
}
.search-row ul li .hover-systemBlue.Icon:hover,.search-row ul li .hover-systemBlue.Icon.curr{
  background: #4697f9 url('../assets/image/images/icons/sub_icon_menu.jpg') no-repeat 3px center / 13px;
}
/* 在文字上显示小箭头 */
.search-row ul li .search-block:hover .hover-systemBlue::after{
  display: inline-block;
}
/* 在悬浮层显示小箭头 */
.search-row ul li .level-area:hover+.search-block .hover-systemBlue::after{
  display: inline-block;
}
.search-row ul li .hover-systemBlue::after{
  content: "";
  display: none;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  position: absolute;
  left: 40%; 
  top: 27px;
  z-index: 999;
}
.search-row ul li .level-area a:hover{
  color: #4697f9;
}
.search-row ul li .hover-systemBlue:hover{
  background-color: #4697f9;
  color: #fff;
}
.search-row ul li .curr{
  background-color: #4697f9;
  color: #fff;
}
.search-row ul li .currs{
  color: #4697f9;
}
.search-row ul li .level-area{
  position: absolute;
  left: 0;
  right: 0;
  top: 40px;
  z-index: 1;
}
.search-row ul li .level-area .level-rows{
  background: #fff;
  box-shadow: 0 0 10px rgb(0 0 0 / 20%);
  padding: 10px;
  box-sizing: border-box;
}
.search-row ul li .level-area .level-rows .info{
  display: inline;
  height: 34px;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;
  font-size: 14px;
  margin-right: 15px;
}
.search-row .label-more{
  position: absolute;
  right: 20px;
  bottom: 10px;
}
.search-row .label-more a{
  line-height: 26px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/chooseConditions.vue